import React from 'react';
import { isValidElementType } from 'react-is';
import { IntlProvider } from '../providers/IntlProvider';

export const withIntl = (Component) => {
  const WrappedComponent = (props) => (
    <IntlProvider>
      <Component {...props} />
    </IntlProvider>
  );

  WrappedComponent.displayName = `withIntl(${Component.displayName || Component.name || 'Component'})`;

  return WrappedComponent;
};

export const wrapAllComponents = (obj) => {
  if (isValidElementType(obj)) {
    return withIntl(obj);
  }

  if (typeof obj === 'object' && obj !== null) {
    const wrapped = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        wrapped[key] = wrapAllComponents(obj[key]);
      }
    }
    return wrapped;
  }

  return obj;
};
